<template>
    <div class="container">
        <div class="rank-top">
            <h1>用户榜</h1>
            <div class="data-picker">
                <el-date-picker @change="dateChane" v-model="dateValue" type="month" value-format="yyyy-MM" clear-icon='' ref="daterange" :picker-options="{
						disabledDate: (date) => {
				          const beginDate = new Date(addTime)
				          const endDate = new Date()
				          return beginDate > date || endDate < date
				        }
				    }" placeholder="选择月">
                </el-date-picker>
                <i class="el-icon-arrow-down append-arrow" @click="changeArrow"></i>
                <!-- <el-date-picker
					@change ="dateChane"
					v-model="dateValue"
					type="datetimerange"
					range-separator="-"
					:time-arrow-control= "true"
					value-format="yyyy-MM-dd"
					start-placeholder="开始日期"
					end-placeholder="结束日期">
				</el-date-picker> -->
            </div>
            <div class="rank-tips">
                <!-- <span>圈子最活跃用户都在这里 </span> -->
                <a href="javascript:;" @click="toRankRules">榜单规则 ></a>
            </div>
            <div class="rankest" v-if="firstThree.length>0">
                <div class="rankest-list rankest-list1" v-if="firstThree.length>=2" @click="toDetail(firstThree[1].addUserId)">
                    <div class="rankest-img">
                        <img :src="firstThree[1].headPic?firstThree[1].headPic:require('@/assets/avatar_icon2.png')" />
                        <span>2</span>
                    </div>
                    <div class="rankest-name">{{firstThree[1].nickName}}</div>
                    <div class="score-num"><span>{{ firstThree[1].integralNum }}</span> <strong>分</strong></div>
                </div>
                <div class="rankest-list rankest-list2" v-if="firstThree.length>=1" @click="toDetail(firstThree[0].addUserId)">
                    <div class="rankest-img">
                        <img :src="firstThree[0].headPic?firstThree[0].headPic:require('@/assets/avatar_icon2.png')" />
                        <span>1</span>
                    </div>
                    <div class="rankest-name">{{firstThree[0].nickName}}</div>
                    <div class="score-num"><span>{{ firstThree[0].integralNum }}</span> <strong>分</strong></div>
                </div>
                <div class="rankest-list rankest-list3" v-if="firstThree.length>=3" @click="toDetail(firstThree[2].addUserId)">
                    <div class="rankest-img">
                        <img :src="firstThree[2].headPic?firstThree[2].headPic:require('@/assets/avatar_icon2.png')" />
                        <span>3</span>
                    </div>
                    <div class="rankest-name">{{firstThree[2].nickName}}</div>
                    <div class="score-num"><span>{{ firstThree[2].integralNum }}</span> <strong>分</strong></div>
                </div>
            </div>
        </div>
        <div class="rank-cnt">
            <div class="rank-list rank-list-my" v-if="selfData" @click="toDetail(selfData.userId)">
                <div class="rank-list-l">
                    <h4 class='my-tiitle'>我的成绩</h4>
                    <div class='my-name'><img style="margin:0 10px" :src="selfData.headPic?selfData.headPic:require('@/assets/avatar_icon2.png')" />
                        <h4>{{selfData.nickName}}</h4>
                    </div>
                </div>
                <div class="rank-list-m" v-if="selfData.rank < 100">
                    第{{selfData.rank}}名
                </div>
                <div class="rank-list-m" v-if="selfData.rank > 99">
                    未上榜
                </div>
                <div class="rank-list-r2">
                    <span>{{selfData.integralNum}}</span>
                    <strong>分</strong>
                </div>
            </div>
            <div v-if="dataList.length>0">
                <div class="rank-list">
                    <el-table :data="dataList" style="width: 100%" :row-class-name="pageNum===1?'hide-first-three':''">
                        <el-table-column label="排名" type="index" width="80" align="center">
                            <template slot-scope="scope">
                                <div @click="toDetail(scope.row.addUserId)">
                                    {{scope.row.rank}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="姓名">
                            <template slot-scope="scope">
                                <div class="rank-list-l" @click="toDetail(scope.row.addUserId)">
                                    <img :src="scope.row.headPic?scope.row.headPic:require('@/assets/avatar_icon2.png')" />
                                    <h3>{{scope.row.nickName}}</h3>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="积分" width="120" align="center">
                            <template slot-scope="scope">
                                <div class="rank-list-r">
                                    <span>{{scope.row.integralNum}}</span>
                                    <strong>分</strong>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="page-coent" v-if="isLastPage == 1">没有更多数据了~</div>
                <!-- <div class="rank-list" v-for="(item,index) in dataList">
					<div class="rank-list-l">
						<span class="rank-num">{{index+1}}</span>
						<img :src="item.headPic" />
						<h3>{{item.nickName}}</h3>
					</div>
					<div class="rank-list-r">
						<span>{{item.integralNum}}</span>积分
					</div>
				</div> -->
            </div>
            <!-- <Empty v-else content="暂无数据"/> -->
            <div v-if="total>pageSize">
                <Pagination :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange" />
            </div>
        </div>
    </div>
</template>
<script>
import Empty from '@/components/empty'
import Pagination from '@/components/pagination'
import qs from 'qs'
import { post, ajaxParam } from '@/units/request.js'
import moment from 'moment'
export default {
    name: 'rank',
    components: {
        Empty,
        Pagination
    },
    data() {
        return {
            userId: '',
            dateValue: '',
            circleId: '',
            beginTime: '',
            endTime: '',
            pageSize: 10,
            pageNum: 1,
            addTime: '',
            firstThree: [],
            dataList: [],
            total: 0,
            isLastPage:0,
            selfData: {}
        }
    },
    created() {
        this.userId = localStorage.getItem('userId')
        this.dateValue = moment().format("yyyy-MM") || ''
        this.circleId = this.$route.query.id
        this.getDataList()
    },
    methods: {
        //获取用户榜单
        async getDataList() {
            let param = {
                userId: this.userId,
                circleId: this.circleId,
                rankDate: this.dateValue,
                pageSize: this.pageSize,
                pageNum: this.pageNum
            }
            ajaxParam(param)
            const res = await post('v1/circle/ranking', qs.stringify(param))
            if (res.data.code == 200) {
                this.dataList = res.data.list
                if(this.pageNum===1){
                    this.firstThree = []
                    res.data.list.forEach((item,index)=>{
                        if(index<=2){
                            this.firstThree.push(item)
                        }
                    })
                }
                this.addTime = res.data.addTime
                this.total = res.data.total
                this.isLastPage = res.data.isLastPage
                this.selfData = res.data.selfData
            } else {
                this.$message.error(res.data.msg)
            }
        },
        pageChange(e) {
            this.dataList = []
            this.pageNum = e.number
            this.getDataList()
        },
        dateChane(e) {
            // this.beginTime = e[0]
            // this.endTime = e[1]
            this.dataList = []
            this.pageNum = 1
            this.getDataList()
        },
        toRankRules() {
            this.$router.push({
                path: '/rankRules'
            })
        },
        changeArrow() {
            this.$refs.daterange.focus();
        },
        toDetail(id) {
            this.$router.push({
                path: '/userIndex?id=' + id
            })
        }
    }
}
</script>
<style lang="less" scoped>
.container {
    width: 680px;
    margin: 20px auto;
}
.page-coent{
    text-align: center;
    margin-top: 10px;
    font-size: 16px;
    font-weight: 600;
}
.rank-top {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 340px;
    padding: 30px 0 0 40px;
    //background: linear-gradient(90deg, #DD0515 0%, rgba(207,23,29,0) 100%);
    background: url('../../assets/rank_bg.png') no-repeat center center;
    background-size: 100% 100%;
    border-radius: 12px;
    box-sizing: border-box;

    h1 {
        font-size: 48px;
        color: #FFFFFF;
        line-height: 58px;
        text-shadow: 0px 6px 16px rgba(174, 4, 9, 0.82);
    }

    .data-picker {
        margin-top: 25px
    }

    .rank-tips {
        display: flex;
        justify-content: space-between;
        width: 300px;
        padding: 25px 0;
        opacity: .7;
        font-size: 16px;
        color: #fff;

        a {
            color: #fff;
            font-size: 14px;
        }
    }
    .rankest {
        position: absolute;
        right: 0;
        width: 55%;

        .rankest-list {
            position: absolute;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 150px;
            top: 118px;
            color: #fff;
            cursor: pointer;

            .rankest-img {
                border-radius: 50%;
                background: #fadc88;
                position: relative;
                margin-bottom: 5px;

                img {
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    margin: 1px;
                }

                span {
                    position: absolute;
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    background: #fadc88;
                    left: -10px;
                    top: 0;
                    text-align: center;
                    line-height: 20px;
                    color: #fff;
                }
            }

        }

        .rankest-list1 {
            left: -38px;
            .rankest-img {
                span {
                    background: #dee5ec;
                }

                background: #dee5ec;
            }
        }

        .rankest-list2 {
            left: 90px;
            top: 60px;
        }

        .rankest-list3 {
            left: 205px;
            top: 160px
        }
    }
}

.rank-cnt {
    background: #fff;
    border-radius: 10px;
    padding: 0 20px 20px;
    overflow: hidden;
    min-height: 300px;
    position: relative;
    margin-top: -20px;

    .my-tiitle {
        width: 40px;
        padding-left: 25px;
        padding-right: 25px;
        color: #DD0515;
        line-height: 18px;
    }

    .my-name {
        display: flex;
        width: 400px;
        align-items: center;
    }

    .rank-list {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;

        .rank-list-l {
            display: flex;
            align-items: center;

            span {
                display: block;
                width: 24px;
                height: 24px;
                background: #C5C4C5;
                border-radius: 4px;
                text-align: center;
                line-height: 24px;
                color: #fff;
            }

            img {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 20px;
            }

            h3 {
                font-size: 14px;
                font-weight: bold;
                line-height: 33px;
            }

        }

        .rank-list-r {
            width: 120px;
            text-align: center;

            // opacity: .7;
            span {
                vertical-align: middle;
                padding-right: 6px;
                font-size: 18px;
                color: #DD0515;
                opacity: 1;
            }

            strong {
                font-weight: normal;
                vertical-align: middle;
            }
        }

        .rank-list-r2 {
            width: 100px;
            text-align: center;

            // opacity: .7;
            span {
                vertical-align: middle;
                padding-right: 6px;
                font-size: 18px;
                color: #DD0515;
                opacity: 1;
            }

            strong {
                font-weight: normal;
                vertical-align: middle;
            }
        }
    }

    .rank-list:nth-of-type(1) .rank-num {
        background: linear-gradient(316deg, #EA3936 0%, #FF726C 100%);
    }

    .rank-list:nth-of-type(2) .rank-num {
        background: linear-gradient(316deg, #FF7E01 0%, #FF9A1D 100%);
    }

    .rank-list:nth-of-type(3) .rank-num {
        background: linear-gradient(316deg, #E0A56F 0%, #F5C380 100%);
    }

    .rank-list:last-of-type {
        border-bottom: none;
    }

    .rank-list-my {
        padding: 20px 0;
        margin-bottom: 10px;

        h1 {
            width: 110px;
            color: #DD0515;
            font-weight: bold;
            opacity: .7;
        }

        .rank-list-l {
            width: 60%;
        }

        .rank-list-m {
            width: 100px;
            color: #DD0515;
            font-weight: bold;
            opacity: .7;
        }
    }

    /deep/ .hide-first-three {
        display: none !important;
    }

    /deep/ .hide-first-three:nth-child(n+4) {
        display: table-row !important;
    }
}

.append-arrow {
    cursor: pointer;
    margin-left: -30px;
    /* 根据你的需求调整位置 */
    position: relative;
    top: 0;
    /* 根据你的需求调整位置 */
}

.rankest-name {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
}

/deep/ .el-table th:nth-child(2).el-table__cell>.cell {
    padding-left: 20px;
}

/deep/ .el-table th:nth-child(3).el-table__cell>.cell {
    padding-left: 30px;
}

/deep/ .el-table__header-wrapper {
    cursor: default;
}
:deep .el-table td, :deep .el-table th.is-leaf{
    border-bottom: none;
}
.score-num{
    span{
        color: #FFFFFF;
        font-weight: bold;
    }
}
:deep .el-table::before{
    height: 0;
}
</style>